import React from 'react';
import Dim from 'web/components/common/modal/common/Dim';
import Coupon from 'shared/components/popup/coupon/Coupon';
import { initModal } from 'shared/actions/modal.action';
import { useSelector, useDispatch } from 'react-redux';
import { getMyCoupon } from 'shared/actions/coupon.action';
import storage from 'shared/utils/storage';
import queryString from 'querystring';

function CouponSuccessContainer({ data, history }) {
  const dispatch = useDispatch();
  const { couponInfo } = useSelector(state => state.shared.coupon);

  const handleClick = () => {
    dispatch(getMyCoupon());
    history.push('/');
    dispatch(initModal());
  };

  const handleClose = () => {
    dispatch(initModal());
  };

  const successImage =
    couponInfo.useAfterImageUrl || storage.get('welcome:couponImage');

  const { repaycode } = queryString.parse(history?.location?.search);

  console.log('repaycode!@!@', { repaycode });

  return repaycode === '' || repaycode === undefined ? (
    <Dim>
      <Coupon
        className="completed"
        image={successImage}
        handleClick={handleClick}
        handleClose={handleClose}
        couponInfo={couponInfo}
        text="바로 수강신청하기 >"
      />
    </Dim>
  ) : (
    ''
  );
}

export default CouponSuccessContainer;
